import { useState, useEffect, useRef } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

/**
 * Hook to fetch app configuration from backend
 * Returns Google Client ID and Maps API Key
 */
export const useAppConfig = () => {
    const [config, setConfig] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const fetchedRef = useRef(false);

    useEffect(() => {
        if (fetchedRef.current) return;
        fetchedRef.current = true;

        const fetchConfig = async () => {
            try {
                const response = await fetch(`${API_URL}/api/config`);
                if (response.ok) {
                    const data = await response.json();
                    setConfig(data);
                    
                    // Dynamically load Google Maps script with the API key
                    if (data.google_maps_api_key && !window.google?.maps) {
                        loadGoogleMapsScript(data.google_maps_api_key);
                    }
                    
                    console.log('✨ App config loaded from backend');
                } else {
                    throw new Error('Failed to fetch config');
                }
            } catch (err) {
                console.error('Config fetch error:', err);
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchConfig();
    }, []);

    return { config, loading, error };
};

/**
 * Load Google Maps script dynamically
 */
const loadGoogleMapsScript = (apiKey) => {
    // Check if already loaded
    if (document.querySelector('script[src*="maps.googleapis.com"]')) {
        return;
    }

    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&callback=Function.prototype`;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
    
    console.log('✨ Google Maps script loaded dynamically');
};

export default useAppConfig;
